var $51f3cfca00ce70a2$exports = {};
"use strict";
var $51f3cfca00ce70a2$var$topNav = document.getElementById("top-nav");
var $51f3cfca00ce70a2$var$linkToCurrentPage = $51f3cfca00ce70a2$var$topNav.firstElementChild;
[
    ...$51f3cfca00ce70a2$var$topNav.children
].forEach((el)=>{
    if (window.location.href.includes(el.dataset.path)) $51f3cfca00ce70a2$var$linkToCurrentPage = el;
});
if ([
    "creating-events",
    "customisation",
    "sharing-events",
    "getting-paid"
].some(function(path) {
    return window.location.href.indexOf(path) >= 0;
})) $51f3cfca00ce70a2$var$linkToCurrentPage = document.getElementById("product-nav");
$51f3cfca00ce70a2$var$linkToCurrentPage.classList.add("underline", "underline-offset-8");
const $51f3cfca00ce70a2$var$navSlide = ()=>{
    const burger = document.querySelector(".burger");
    const nav = document.querySelector(".nav-links");
    // const navLinks = document.querySelectorAll(".nav-links a");
    burger.addEventListener("click", ()=>{
        nav.classList.toggle("nav-active");
        burger.classList.toggle("toggle");
    });
};
$51f3cfca00ce70a2$var$navSlide();
document.addEventListener("DOMContentLoaded", ()=>{
    const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
    dropdownToggles.forEach((toggle)=>{
        toggle.addEventListener("click", ()=>{
            const dropdownMenu = toggle.nextElementSibling;
            if (dropdownMenu.classList.contains("hidden")) {
                document.querySelectorAll(".dropdown-menu").forEach((menu)=>{
                    menu.classList.add("hidden");
                });
                dropdownMenu.classList.remove("hidden");
            } else dropdownMenu.classList.add("hidden");
        });
    });
    window.addEventListener("click", (event)=>{
        if (!event.target.matches(".dropdown-toggle")) document.querySelectorAll(".dropdown-menu").forEach((menu)=>{
            if (!menu.contains(event.target)) menu.classList.add("hidden");
        });
    });
});


//# sourceMappingURL=my-orders_com.101dd5fb.js.map
